const setSelectedStatusAction = ({ commit }: any, status: string) => {
  commit('setSelectedStatus', status)
}

export default {
  setSelectedStatusAction,
}
